export default __webpack_public_path__ + "static/media/salad-map-dot-viewed.5a0fa0b4.svg";